import React, { Component } from 'react';
import {  Link } from "react-router-dom";
import './index.scss';


export default  class RouterMovingContainer extends Component {
  constructor(props) {
    super(props)
    this.currentIndex = 0;
    this.pastIndex = -1;
    this.cachePastIndex = -1;
    this.data = [];
    this.routesWays = [];
  }
  setIndex = (e) => {
    this.currentIndex = e;
  }
  execute = (i, current) => {
    setTimeout(() => {
      if (i === current) {
        if (this.data[current] && this.data[current].wrappedInstance && this.data[current].wrappedInstance.onEnterScreen) {
          this.data[current].wrappedInstance.onEnterScreen()
        }
      }
      if (this.currentIndex === i) {
     
      }

    }, this.props.options && this.props.options.animation && this.props.options.animation.duration ? this.props.options.animation.duration : 250)
  }
  render() {
    let routing = this.props.availableRoutes;

    let path = this.props.history.location.pathname;
    var i;
    
    // arr.splice(0, 0, "Lene");
    let look =  this.routesWays.indexOf(path)
    if (look === -1) {
      this.routesWays.push(path);
    }

    
    for (i = 0; i < routing.length; i++) {
        if (routing[i].route === path) {
          if (this.pastIndex !== this.currentIndex) {
            this.cachePastIndex = this.pastIndex;
            this.pastIndex = this.currentIndex

          }
      
          // this.pastIndex = i;
          this.currentIndex = i;
          if (this.pastIndex === this.currentIndex) {
            this.pastIndex = this.cachePastIndex
           }
          routing[i].negative = true;
          routing[i].loaded = true;
      
        }
    }
    let push = false;
    if (routing[this.pastIndex] && routing[this.pastIndex].order) {
      if (routing[this.pastIndex].order < routing[this.currentIndex].order) {
        push = true
      }
    }  else {
      push = true
    }

  
    let styling = [];
    let duration = this.props.options && this.props.options.animation && this.props.options.animation.duration ? this.props.options.animation.duration : 250;
    for (i = 0; i < routing.length; i++) {
      let plus = false;
        if (routing[i].order > routing[this.currentIndex].order) {
          plus = true;
        }
        styling.push({
          opacity:0,
          pointerEvents:'none',
          transition:`transform 0s cubic-bezier(0.4, 0, 0.2, 1)`,
          transform : `translate3d(${plus ? '100%' : '-100%'}, 0px, 0)`
       })
    }
    return (
      <div className={`authContainer ${this.props.parentClassName}`}>
              {routing.map((item, i) => {
                if (this.pastIndex === i) {
                  styling[i].transition = `transform ${duration} cubic-bezier(0.4, 0, 0.2, 1)`
                  styling[i].opacity = 1;
                  styling[i].pointerEvents = 'auto';
                  styling[i].transform = `translate3d(${push ? '-100%' : '100%'}, 0px, 0)`;
                }
                if (this.currentIndex === i) {
                  styling[i].transition = `transform ${duration} cubic-bezier(0.4, 0, 0.2, 1)`
                  styling[i].opacity = 1;
                  styling[i].pointerEvents = 'auto';
                  styling[i].transform = `translate3d(0px, 0px, 0)`;
                }
                return (
                    <div style={styling[i]} key={i} className="authContainer-beside" >
                  <div className="testS" >
                     {/* LAZY LOADING */}
                  {item.component && item.loaded ? <item.component
                                ref ={ (data) => {this.data[i] = data}}
                                {...item.props}
                                {...this.props}

                                /> : null}
                  {this.props.options && this.props.options.showLinks ?
                                     routing.map((item, i) =>{
                                      return <li key={i+'liii'}><Link to={item.route}>{item.route}</Link></li>;
                                     })
                                : null}
                  </div>
                    
                    </div>
                );
              })}
      </div>
    );
  }
}







// WEBPACK FOOTER //
// ./src/components/functional/animated-router/animationContainer.js